<template>
  <div id="scroll">
    <div class="container">
      新闻中心
      <el-select v-model="query.type" clearable placeholder="请选择类型" @change="getData('select')">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      <el-button type="success" @click="addNew()">添加</el-button>
      <el-button
        type="danger"
        icon="el-icon-delete"
        @click="handleDelete(deleteArr)"
        >批量删除</el-button
      >
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="type" label="体系类别"> 
          <template slot-scope="scope">
          <span v-if="scope.row.type==1">公司新闻</span>
          <span v-else-if="scope.row.type==2">行业动态</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column prop="pictureId" label="插图">
           <template slot-scope="scope">
            <el-image
              style="width: 1.25rem; height: 1.25rem"
              v-show="scope.row.sysPicture"
              :src="scope.row.img"
              :preview-src-list="srcList"
            >
            </el-image>
          </template>
           </el-table-column>
           <el-table-column prop="createTime" label="发布时间" :sortable="'custom'" >
          <template slot-scope="scope">
                 {{scope.row.createTime | seTimeFilter('sjx')}}
          </template>
           </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="addNew(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageNo"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
    </div>

  </div>
</template>

<script>
import { getNewsList,getSysNews,delSysNews } from "@/api/manage";
import config from "@/config/url.config";
export default {
  data() {
    return {
      query: {
        type:'',
        pageNo: 1,
        pageSize: 10,
        sortType:'a'
      },
      pageTotal:0,
      srcList:[],
      key:1,
      tableData:[],
      deleteArr:[],
      options:[{value:1,label:'公司新闻'},{value:2,label:'行业动态'}],
    };
  },
  created() {},
  mounted() {
      this.getData()
  },
  methods: {
    async getData(a) {
        //获取公司新闻列表
        if(a=='select'){
          this.query.pageNo=1
        }
        this.tableData=[]
      let res = await getSysNews(this.query);
      if(res.code==250){
           
      }else if(res.code==200){
        this.srcList=[]
        res.data.forEach((item) => {
          let url = item.sysPicture
            ? config.baseURL + item.sysPicture.fileUrl + item.sysPicture.newName
            : "";
          item.img = url;
          this.srcList.push(url)
        });
        this.tableData=res.data
        this.pageTotal=+res.total
       // console.log('this.tableData',this.tableData);
      }
    },
    handleSelectionChange(val){
       //多选操作,批量删除
      this.deleteArr = [];
      val.map((item) => {
        this.deleteArr.push(item.id);
      });
    },
    addNew(data){
        //新增或编辑
        if(!data){
          this.$router.replace({
            name: "newsAdd",
        params: { typeOf: "add" },
          })
        }else{
          let replaceTxt = 'http://116.206.94.117:8195//uploading'
      let newTxt = 'http://101.89.182.189:8191//uploading'
      let text = encodeURI(decodeURI(data.content).replace(new RegExp(replaceTxt,'g'),newTxt));
          this.$router.replace({
            name: "newsAdd",
        params: { typeOf: "edit",id:data.id,title:data.title,type:data.type,content:text,time:data.createTime,img:data.img,pictureId:data.pictureId },
          })
        }
    },
    handleDelete(ids){
   //删除或批量删除
    if(ids.length==0){
      return this.$message.error('未选择删除项')
    }
    this.$confirm("此操作将永久删除该新闻, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let param = {};
            param.ids = Array.isArray(ids)
              ? JSON.stringify(ids)
              : JSON.stringify([ids]);
          let res = await delSysNews(param);
          if (res.code == 200) {
            this.$message.success('删除成功!')
            console.log('param.ids',param.ids);
            if((JSON.parse(param.ids)).length==this.tableData.length){
              console.log('456456');
             this.query.pageNo--
           }
            this.getData();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handlePageChange(val) {
          this.$set(this.query, 'pageNo', val);
          this.getData()
      },
      sortChange(){
         this.query.sortType?this.query.sortType='':this.query.sortType='a'
          this.getData()
      },
  },
};
</script>

<style lang="less" scoped>
#scroll {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.red {
  color: #f56c6c;
}
.el-table /deep/ th{
  overflow: unset;
}
</style>